// Loads the Google Maps JavaScript API once and resolves when window.google.maps is ready.
// The key is the BROWSER key (referrer-restricted to the site), fetched from /api/maps-config.
let loadPromise = null;

export function loadGoogleMaps(key) {
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (loadPromise) return loadPromise;
  if (!key) return Promise.reject(new Error('no-key'));
  loadPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=marker`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(window.google.maps);
    s.onerror = () => { loadPromise = null; reject(new Error('script-load-failed')); };
    document.head.appendChild(s);
  });
  return loadPromise;
}
